var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryCar = function SvgDeliveryCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 77 77"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M16.004 54.398a6.4 6.4 0 1 0 12.8 0 6.4 6.4 0 0 0-12.8 0m32 0a6.4 6.4 0 1 0 12.8 0 6.4 6.4 0 0 0-12.8 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M16.006 54.395h-6.4v-19.2m0 0 6.4-16h28.8l12.8 16m-48 0h48m0 0h3.2a6.4 6.4 0 0 1 6.4 6.4v12.8h-6.4m-12.8 0h-19.2m9.6-19.2v-16"
  })));
};
export default SvgDeliveryCar;